import { useEffect, useRef, type MutableRefObject } from 'react';

import { captureBylineLifecycle, type BylineLifecycle } from './bylineLifecycleMetrics.ts';

export const useBylineLifecycle = (
	contentId: string | undefined,
): MutableRefObject<BylineLifecycle> => {
	const recorder = useRef<BylineLifecycle>(null);
	useEffect(() => {
		recorder.current = captureBylineLifecycle();
		return () => {
			recorder.current?.cancel?.();
			recorder.current = null;
		};
	}, [contentId]);
	return recorder;
};
